exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputBar {\n    width: 100%;\n    display: flex;\n    flex-shrink: 0;\n}\n\n.inputBar-input {\n    padding: 8px;\n    flex-grow: 1;\n    font-size: 16px;\n}\n\n.inputBar-sendButton {\n    background: #009;\n    color: white;\n    border: none;\n    padding: 4px 8px;\n    font-size: 18px;\n}", ""]);

// exports
